function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0.634)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1.907 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M598.5,373.893a.491.491,0,0,1-.348-.144l-2.689-2.689a.492.492,0,0,1,0-.7l13.788-13.788a.492.492,0,1,1,.7.7l-13.44,13.44,1.994,1.994,13.44-13.439a.492.492,0,0,1,.7.7l-13.788,13.787A.49.49,0,0,1,598.5,373.893Z",
  transform: "translate(-595.315 -356.432)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 13.788)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M589.993,404.062a.492.492,0,0,1-.454-.68l1.907-4.6a.492.492,0,1,1,.909.377l-1.451,3.5,3.5-1.451a.492.492,0,0,1,.377.909l-4.6,1.907A.492.492,0,0,1,589.993,404.062Z",
  transform: "translate(-589.501 -398.482)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(15.771)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M640.781,358.728a.492.492,0,0,1-.348-.84,1.41,1.41,0,1,0-1.993-1.994.492.492,0,0,1-.7-.7,2.393,2.393,0,1,1,3.385,3.385A.49.49,0,0,1,640.781,358.728Z",
  transform: "translate(-637.6 -354.498)"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(14.427 1.902)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M636.681,363.973a.49.49,0,0,1-.348-.144l-2.69-2.69a.492.492,0,0,1,.7-.7l2.69,2.69a.492.492,0,0,1-.348.84Z",
  transform: "translate(-633.499 -360.299)"
}));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20.001,
      height: 20.002,
      viewBox: "0 0 20.001 20.002",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgEdit, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/edit.7a70ec19.svg";
export { ForwardRef as ReactComponent };